// extracted by mini-css-extract-plugin
module.exports = {"interested-products":"interestedProducts_interested-products__aax8G","title":"interestedProducts_title__HryKk"};